module.exports = __webpack_public_path__ + "img/mobilelsobek.a8fddbe9.svg";